import { IncomingMessage } from 'http';
import cookieParser from 'cookie';

type Headers = { Authorization: string };

function getHeadersForServerSideRequest(req?: IncomingMessage): {
  headers?: Headers;
} {
  let headers = {};
  const isServer = !!req;

  if (isServer) {
    const parsedCookie = cookieParser.parse(req.headers.cookie || '');

    if (parsedCookie['token']) {
      headers = {
        headers: {
          Authorization: `Bearer ${parsedCookie['token']}`,
        },
      };
    }
  }

  return headers;
}

export default getHeadersForServerSideRequest;
